import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Employee } from '@app/features/employees/employee.model';
import { RUNTIME_CONFIG } from '@environments/runtime-config.token';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class EmployeeService {
  private httpClient = inject(HttpClient);
  private url = `${inject(RUNTIME_CONFIG).apiUrl}/employees`;

  search(search: string): Observable<Employee[]> {
    return this.httpClient.get<Employee[]>(`${this.url}/search?query=${search}`);
  }
}
